var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/naming-convention -- the current settings do not make much sense in JSX environment */
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet } from 'react-router-dom';
import { Box, ToastContainer } from '@lucidlink/uicore';
import { usePollFilespaceLists, WorkspaceFilespaceLists, } from '@lucidlink/workspacemanagement';
import { ExperimentalFeature, LucidDevToolsWidget, SkipLink, TwoFactorAuthenticationToasts, } from '@lucidlink/workspacemanagement/components';
import { DEPENDENCY_KEYS, useAppUi, useDependency, useLucidDevTools, } from '@lucidlink/workspacemanagement/context';
import { useSetAmplitudeUser, useUserRoleChangeNotifier, useWorkspaceAuthorization, } from '@lucidlink/workspacemanagement/hooks';
import { AppDrawer } from '@lucidlink/workspacemanagement/router/components';
import { ExposeLucidSdk } from '#components';
import { useHandleGuestLinkBroadcast } from '#features/guest-links';
import { useUpgradeRequired } from '#hooks';
import { ObservableRootLogger } from '#services';
import styles from './Main.module.css';
export const Main = () => {
    _react_refresh_temp_2();
    // External script management
    useSetAmplitudeUser();
    const workspaceFilespaceLists = usePollFilespaceLists();
    useUserRoleChangeNotifier();
    useDependency(DEPENDENCY_KEYS.UseFilespacesDisconnectOnNoAccess)();
    useDependency(DEPENDENCY_KEYS.UseReconnectFilespaces)();
    useDependency(DEPENDENCY_KEYS.UseHandleMissingCacheLocation)();
    useDependency(DEPENDENCY_KEYS.UseOnCurrentUserChange)();
    const { logoutFlow: { isLogoutFlowInProgress }, } = useAppUi();
    // Feature layer management
    const LogoutFlow = useDependency(DEPENDENCY_KEYS.LogoutFlow);
    // Interface layer management
    useDependency(DEPENDENCY_KEYS.UseNotificationMessages)();
    // TODO: Consider how to unify the below two subscribes
    // https://lucidlink.atlassian.net/browse/LUCID-23989
    useWorkspaceAuthorization();
    useUpgradeRequired();
    useHandleGuestLinkBroadcast();
    const { isLucidDevToolsWidgetOpen } = useLucidDevTools();
    return (_jsxs(_Fragment, { children: [!isLogoutFlowInProgress && _jsx(SkipLink, {}), _jsx(WorkspaceFilespaceLists, { workspaceFilespaceLists: workspaceFilespaceLists }), _jsxs(Box, { className: styles.Container, inert: isLogoutFlowInProgress, isFullHeight: true, orientation: "vertical", children: [_jsx(Outlet, {}), isLucidDevToolsWidgetOpen ? (_jsx(ExperimentalFeature, { children: _jsx(LucidDevToolsWidget, { observableLogger: ObservableRootLogger }) })) : null] }), _jsx(ExperimentalFeature, { children: _jsx(ExposeLucidSdk, {}) }), _jsx(AppDrawer, { isInert: isLogoutFlowInProgress }), _jsx(ToastContainer, {}), _jsx(TwoFactorAuthenticationToasts, {}), isLogoutFlowInProgress ? _jsx(LogoutFlow, {}) : null, _jsx(ReactQueryDevtools, { buttonPosition: "bottom-left", initialIsOpen: false })] }));
};
_react_refresh_temp_1 = Main;
$RefreshReg$(_react_refresh_temp_1, "Main");
_react_refresh_temp_2(Main, "84lnZDV++0ZvJ4kSUvih59dpXAQ=", false, () => [
    // External script management
    useSetAmplitudeUser, usePollFilespaceLists, useUserRoleChangeNotifier, useDependency, useDependency, useDependency, useDependency, useAppUi, useDependency, 
    // Interface layer management
    useDependency, 
    // TODO: Consider how to unify the below two subscribes
    // https://lucidlink.atlassian.net/browse/LUCID-23989
    useWorkspaceAuthorization, useUpgradeRequired, useHandleGuestLinkBroadcast, useLucidDevTools]);
